import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { Sessions } from '../../helpers/schema';

export const schema = z.object({
  inviteCode: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  session: Selectable<Sessions>;
  alreadyJoined: boolean;
};

export const acceptInvitation = async (
  body: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/invitations/accept`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
